import PropTypes from 'prop-types';

import Checkbox from '../../../../common/inputs/checkbox/Checkbox';
import Button from '../../../../common/button/Button';

import { ReactComponent as LogoDark } from '../../../../../resources/logos/atp-logo-light.svg';

import './permission-selection.scss';

const PermissionSelection = ({ setScreenStep, addPermission, removePermission, isPermissionInList }) => {
  const addOrRemovePermission = (permission) => {
    if (isPermissionInList(permission)) {
      removePermission(permission);
    } else {
      addPermission(permission);
    }
  };

  return (
    <section className="permission_selection">
      <div className="permission_selection__logo">
        <LogoDark />
      </div>

      <div className="permission_selection__heading">
        <h1>Step 1:</h1>
      </div>

      <div className="permission_selection__step">
        <div className="permission_selection__back">
          <p onClick={() => setScreenStep(1)}>{'<'}Back</p>
        </div>

        <div className="permission_selection__body">
          <div className="permission_selection__checkbox-heading">
            <p>Notification Permissions</p>
            <h2>(You can always edit these later in your account settings)</h2>
          </div>
          <div className="permission_selection__checkbox">
            <Checkbox
              value={isPermissionInList('Notification')}
              onChange={() => addOrRemovePermission('Notification')}
            />
            <p>Receive e-mail notifications</p>
          </div>
          <div className="permission_selection__checkbox-heading">
            <p>Contact Permissions</p>
            <h2>(You can always edit these later in your account settings)</h2>
          </div>
          <div className="permission_selection__checkbox">
            <Checkbox value={isPermissionInList('Contact')} onChange={() => addOrRemovePermission('Contact')} />
            <p>
              Make my account visible so other users can contact me directly through the app. (This does not include
              your contact details, only facilitated communication in this app)
            </p>
          </div>
          <div className="permission_selection__checkbox-heading">
            <p>Market Permissions</p>
            <h2>(You can always edit these later in your account settings)</h2>
          </div>
          <div className="permission_selection__checkbox">
            <Checkbox value={isPermissionInList('Marketing')} onChange={() => addOrRemovePermission('Marketing')} />
            <p>Subscribe to marketing e-mail communications</p>
          </div>
          <div className="permission_selection__button-container">
            <Button onClick={() => setScreenStep(2)}>Continue</Button>
          </div>
        </div>
        <div className="permission_selection__skip">
          <p onClick={() => setScreenStep(2)}>Skip{'>'}</p>
        </div>
      </div>
    </section>
  );
};

PermissionSelection.propTypes = {
  setScreenStep: PropTypes.func.isRequired,
  addPermission: PropTypes.func.isRequired,
  removePermission: PropTypes.func.isRequired,
  isPermissionInList: PropTypes.func.isRequired,
};

export default PermissionSelection;
